// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcp_a bhh_ea bhh_kb bhh_js bhh_sl bhh_wj"};